(($) => {
    $(document).ready(() => {
        $('.pardot-handle').find('input, textarea, select').each(function(idex, elm) {
            var $elm = $(elm);
            $elm.attr('name', $elm.attr('name').replace(/ /g, 'z1z')); // field name encode
        })

        // @links: https://jqueryvalidation.org/
        $('.pardot-handle').validate();

        $('.pardot-handle select').on('change', function(e) {
            let input = $(this);

            if (input.val() == '') {
                input.addClass('empty');
            } else {
                input.removeClass('empty');
            }
        });

        $('.pardot-handle select').change();

        $('.pardot-submit').on('submit', function(e) {
            e.preventDefault();
            var that = $(this);

            var form_data = jQuery(this).serializeArray();
            form_data.push({ "name": "action", "value": "pardot_form" });

            // Here is the ajax petition.
            jQuery.ajax({
                url: jsData.ajaxUrl,
                type: 'POST',
                data: form_data,
                success: function(response) {
                    if (response.status) {
                        window.location = response.redirect;
                    } else {
                        //SWD-307: fix show message many times
                        if (that.children(".err").length == 0) {
                            that.append('<span class="err">' + response.message + '</span>');
                        }
                    }
                },
                fail: function(err) {
                    that.append('<span class="err">Something wrong when try subscription.</span>')
                }
            });
            return false;
        })
    });
})(jQuery);